var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 296.72,
    height: 240.551,
    viewBox: "0 0 296.72 240.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9472",
    "data-name": "Path 9472",
    d: "M261.24,359.38,253,371.736l17.067,5.3,7.066-12.356Z",
    transform: "translate(-253 -359.38)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9478",
    "data-name": "Path 9478",
    d: "M363.391,358.029c-2.092-1.347-5.267-1.227-6.539,1.264-1.881,3.627-.534,10.347-1.211,11.287s-2.686,1.211-3.627-.805-.941-4.7-2.152-4.839-2.822.406-3.093,3.5.271,6.584,2.423,8.195,4.568,1.076,5.267,1.753,0,1.731,0,2.423c0,3.01,3.936,4.515,6.426,3.763,3.627-1.076,3.228-4.711,3.762-6.186s3.5-1.618,4.575-3.9,2.686-6.863.4-8.609-4.033-.941-4.3.941a17.625,17.625,0,0,1-1.505,4.3C365.431,367.939,367.011,360.362,363.391,358.029Z",
    transform: "translate(-346.704 -357.174)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9587",
    "data-name": "Path 9587",
    d: "M292.76,255.069c1.4,3.642,3.085,11.476,1.964,15.953a112.433,112.433,0,0,1-4.244,11.37l42.794,22.364c-.045-8.91.068-22.974,1.2-25.585,1.678-3.921,15.118-40.868,14.3-49.266S331.7,209.468,331.7,209.468L334.192,189l-14.832,8.962s-1.686,8.112-3.364,10.076-15.4,4.756-19.317,9.782-2.521,20.438-2.521,21.273S291.36,251.457,292.76,255.069Z",
    transform: "translate(-290.48 -189)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9593",
    "data-name": "Path 9593",
    d: "M299.97,138.491s1.964,10.083,1.678,17.082-3.078,9.782-2.257,12.875,10.919,14.561,17.074,15.674,20.716-8.4,24.915-12.6a15.63,15.63,0,0,0,4.2-12.875c-.557-2.521-2.8-22.673-11.2-30.792S303.891,120.582,299.97,138.491Z",
    transform: "translate(-299.24 -122.928)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9615",
    "data-name": "Path 9615",
    d: "M314.014,251.463,294.7,295.416s-52.63,9.782-57.385,9.782-14.3,3.356-16.239,4.515-20.972,9.9-17.307,10.437c2.257.339,8.1-2.875,8.1-2.875s-9.241,4.515-8.405,5.877,12.04-4.2,12.04-4.2-10.241,6.02-8.142,6.359c1.911.339,4.221-.753,6.186-2.16a22.757,22.757,0,0,1,5.486-2.438s-4.515,3.01-5.049,4.38,1.121.557,2.8,0a69.407,69.407,0,0,0,9.083-4.741c1.114-.843,4.477-2.521,6.72-4.477l4.477-3.921s29.949.835,43.645.278,20.438-1.956,25.479-7S325.5,268.281,328.854,259.6s1.121-13.718-2.258-19.565",
    transform: "translate(-203.299 -240.04)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9620",
    "data-name": "Path 9620",
    d: "M277.87,280.62c-5.681,1.663-28.121,8.232-30.205,8.721a32.051,32.051,0,0,1-3.921.7s-7.841-3.364-9.94-4.9-4.62-.564-5.877,0-2.257,4.477.143,4.477,2.8-.143,5.456,2.1,2.664,3.364,4.62,4.2,5.185.278,6.863,0c1.5-.248,27.526-1.979,33.93-2.318C279.773,290.079,278.938,284.578,277.87,280.62Z",
    transform: "translate(-226.608 -280.62)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designer_girl-bro",
    "data-name": "Designer girl-bro",
    transform: "translate(-51.402 -100.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-118",
    transform: "translate(60.129 100.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9461",
    "data-name": "Path 9461",
    d: "M317.6,304.286S350.8,275.165,350.8,236.735,329.252,198.3,310.613,148.8s-71.63-55.9-103.656-40.183c-27.18,13.349-34.938,53.578-58.236,61.148S123.136,158.7,85.827,168.6s-18.06,64.06-18.06,64.06l72.24-22.131Z",
    transform: "translate(-62.803 -100.999)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1--inject-118",
    transform: "translate(77.833 249.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9463",
    "data-name": "Path 9463",
    d: "M194.689,356.645l-50.161,20.069-58.2-58.2L124.459,313l70.23,43.645",
    transform: "translate(-86.33 -301.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9464",
    "data-name": "Path 9464",
    d: "M194.689,356.645l-50.161,20.069-58.2-58.2L124.459,313l70.23,43.645",
    transform: "translate(-86.33 -301.961)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 12.04,
    cy: 8.029,
    rx: 12.04,
    ry: 8.029,
    transform: "translate(158.024 65.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 12.04,
    cy: 8.029,
    rx: 12.04,
    ry: 8.029,
    transform: "translate(158.024 65.219)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9465",
    "data-name": "Path 9465",
    d: "M249.67,334.244l73.5,5.824-16.314-8.4-57.19,2.574",
    transform: "translate(-126.757 -306.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9466",
    "data-name": "Path 9466",
    d: "M249.67,334.244l73.5,5.824-16.314-8.4-57.19,2.574",
    transform: "translate(-126.757 -306.582)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9467",
    "data-name": "Path 9467",
    d: "M264.5,303.349l-21.807-1.783,2.739-3.236h12.544l6.524,5.019",
    transform: "translate(-125.03 -298.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9468",
    "data-name": "Path 9468",
    d: "M264.5,303.349l-21.807-1.783,2.739-3.236h12.544l6.524,5.019",
    transform: "translate(-125.03 -298.33)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 15.298,
    cy: 9.278,
    rx: 15.298,
    ry: 9.278,
    transform: "translate(194.881 73.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 15.298,
    cy: 9.278,
    rx: 15.298,
    ry: 9.278,
    transform: "translate(194.881 73.504)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Post-it--inject-1--inject-118",
    transform: "translate(189.12 295.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9469",
    "data-name": "Path 9469",
    d: "M242.46,379.71l-8.24,13.537,18.248,3.537,7.066-13.537Z",
    transform: "translate(-234.22 -364.412)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9470",
    "data-name": "Path 9470",
    d: "M261.24,359.38,253,371.736l17.067,5.3,7.066-12.356Z",
    transform: "translate(-238.868 -359.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4098",
    "data-name": "Group 4098",
    transform: "translate(14.132)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9471",
    "data-name": "Path 9471",
    d: "M261.24,359.38,253,371.736l17.067,5.3,7.066-12.356Z",
    transform: "translate(-253 -359.38)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9473",
    "data-name": "Path 9473",
    d: "M261.24,359.38,253,371.736l17.067,5.3,7.066-12.356Z",
    transform: "translate(-238.868 -359.38)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9474",
    "data-name": "Path 9474",
    d: "M283.359,390.67l-14.719,4.116,5.885,9.421,17.074-4.124Z",
    transform: "translate(-242.739 -367.124)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1--inject-118",
    transform: "translate(271.699 293.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9475",
    "data-name": "Path 9475",
    d: "M344,387.46l1.505,11.43c0,4.733,5.757,8.578,12.86,8.578s12.868-3.845,12.868-8.578l1.55-11.43Z",
    transform: "translate(-343.97 -364.67)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 14.41,
    cy: 9.609,
    rx: 14.41,
    ry: 9.609,
    transform: "translate(0 13.18)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 12.258,
    cy: 8.172,
    rx: 12.258,
    ry: 8.172,
    transform: "translate(2.152 14.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 12.047,
    cy: 6.697,
    rx: 12.047,
    ry: 6.697,
    transform: "translate(2.363 17.575)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9476",
    "data-name": "Path 9476",
    d: "M363.391,358.029c-2.092-1.347-5.267-1.227-6.539,1.264-1.881,3.627-.534,10.347-1.211,11.287s-2.686,1.211-3.627-.805-.941-4.7-2.152-4.839-2.822.406-3.093,3.5.271,6.584,2.423,8.195,4.568,1.076,5.267,1.753,0,1.731,0,2.423c0,3.01,3.936,4.515,6.426,3.763,3.627-1.076,3.228-4.711,3.762-6.186s3.5-1.618,4.575-3.9,2.686-6.863.4-8.609-4.033-.941-4.3.941a17.625,17.625,0,0,1-1.505,4.3C365.431,367.939,367.011,360.362,363.391,358.029Z",
    transform: "translate(-344.639 -357.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4099",
    "data-name": "Group 4099",
    transform: "translate(2.065)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9477",
    "data-name": "Path 9477",
    d: "M363.391,358.029c-2.092-1.347-5.267-1.227-6.539,1.264-1.881,3.627-.534,10.347-1.211,11.287s-2.686,1.211-3.627-.805-.941-4.7-2.152-4.839-2.822.406-3.093,3.5.271,6.584,2.423,8.195,4.568,1.076,5.267,1.753,0,1.731,0,2.423c0,3.01,3.936,4.515,6.426,3.763,3.627-1.076,3.228-4.711,3.762-6.186s3.5-1.618,4.575-3.9,2.686-6.863.4-8.609-4.033-.941-4.3.941a17.625,17.625,0,0,1-1.505,4.3C365.431,367.939,367.011,360.362,363.391,358.029Z",
    transform: "translate(-346.704 -357.174)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9479",
    "data-name": "Path 9479",
    d: "M363.391,358.029c-2.092-1.347-5.267-1.227-6.539,1.264-1.881,3.627-.534,10.347-1.211,11.287s-2.686,1.211-3.627-.805-.941-4.7-2.152-4.839-2.822.406-3.093,3.5.271,6.584,2.423,8.195,4.568,1.076,5.267,1.753,0,1.731,0,2.423c0,3.01,3.936,4.515,6.426,3.763,3.627-1.076,3.228-4.711,3.762-6.186s3.5-1.618,4.575-3.9,2.686-6.863.4-8.609-4.033-.941-4.3.941a17.625,17.625,0,0,1-1.505,4.3C365.431,367.939,367.011,360.362,363.391,358.029Z",
    transform: "translate(-344.639 -357.174)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9480",
    "data-name": "Path 9480",
    d: "M361.055,359.63a4.816,4.816,0,0,0-2.152,3.627c-.135,2.423,0,10.083-.941,11.159s-4.033.805-6.02-1.076-1.106-5.907-1.106-5.907",
    transform: "translate(-345.614 -357.782)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9481",
    "data-name": "Path 9481",
    d: "M351.69,381a6.117,6.117,0,0,0,2.363,1.129c2.423.534,4.169-.67,4.575.534s-.406,5.516-.406,5.516",
    transform: "translate(-345.873 -363.071)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9482",
    "data-name": "Path 9482",
    d: "M349.83,379.1a6.078,6.078,0,0,0,.858.971",
    transform: "translate(-345.413 -362.601)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9483",
    "data-name": "Path 9483",
    d: "M364.42,381.969a50.089,50.089,0,0,0,.045-6.02c-.241-3.01,1.159-8.6,1.505-11.129",
    transform: "translate(-349.024 -359.067)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9484",
    "data-name": "Path 9484",
    d: "M364.12,391.124s.075-.82.158-2.024",
    transform: "translate(-348.95 -365.076)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9485",
    "data-name": "Path 9485",
    d: "M376.49,373.544c.068-.655.105-1.053.105-1.053",
    transform: "translate(-352.011 -360.965)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9486",
    "data-name": "Path 9486",
    d: "M368.05,385.437s.542-4.432,1.618-5.267,4.161-1.347,4.432-3.364c.045-.316.083-.617.12-.9",
    transform: "translate(-349.922 -361.811)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9487",
    "data-name": "Path 9487",
    d: "M373.157,370.17a1.859,1.859,0,0,0-.813,1.746,4.319,4.319,0,0,1-2.145,4.033",
    transform: "translate(-350.454 -360.391)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9488",
    "data-name": "Path 9488",
    d: "M366.665,362.038a15.359,15.359,0,0,0-.045-2.258",
    transform: "translate(-349.568 -357.819)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cup--inject-1--inject-118",
    transform: "translate(236.226 281.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9489",
    "data-name": "Path 9489",
    d: "M298.58,358.788l1.994,20.995V382c0,3.01,4.229,5.4,9.451,5.4s9.451-2.415,9.451-5.4v-2.22l1.813-21.213Z",
    transform: "translate(-297.256 -345.228)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9490",
    "data-name": "Path 9490",
    d: "M319.795,381.107l1.046-12.228c-1.407,2.19-5.606,3.762-10.573,3.762-5.23,0-9.6-1.761-10.768-4.131l1.189,12.522c1.926,1.6,5.486,2.686,9.579,2.686S317.868,382.687,319.795,381.107Z",
    transform: "translate(-297.483 -347.688)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9491",
    "data-name": "Path 9491",
    d: "M299.048,363.8v-.143l-.1-.843Z",
    transform: "translate(-297.347 -346.278)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9492",
    "data-name": "Path 9492",
    d: "M321.216,353.307c-2-2.528-6.449-4.3-11.626-4.3s-9.624,1.768-11.634,4.3H296.82v3.01c0,4.033,5.719,7.3,12.792,7.3s12.792-3.266,12.792-7.3v-3.01Z",
    transform: "translate(-296.82 -342.862)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9493",
    "data-name": "Path 9493",
    d: "M321.216,353.307c-2-2.528-6.449-4.3-11.626-4.3s-9.624,1.768-11.634,4.3H296.82v3.01c0,4.033,5.719,7.3,12.792,7.3s12.792-3.266,12.792-7.3v-3.01Z",
    transform: "translate(-296.82 -342.862)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 12.77,
    cy: 7.299,
    rx: 12.77,
    ry: 7.299,
    transform: "translate(0 3.145)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9494",
    "data-name": "Path 9494",
    d: "M320.288,348.072c-1.753-2.212-5.636-3.762-10.159-3.762s-8.405,1.543-10.159,3.762H299v2.619c0,3.522,4.989,6.374,11.152,6.374s11.152-2.852,11.152-6.374v-2.619Z",
    transform: "translate(-297.36 -341.699)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 11.152,
    cy: 6.374,
    rx: 11.152,
    ry: 6.374,
    transform: "translate(1.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-1--inject-118",
    transform: "translate(107.191 172.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9495",
    "data-name": "Path 9495",
    d: "M164.21,267.039s.873-.579,6.411,1.746,7.713,1.821,13.1.873c6.471-1.129,11.844-2.257,12.491.361,1.121,4.515-3.409,4.462-11.558,5.335a26.675,26.675,0,0,1-15.494-2.784,26.386,26.386,0,0,1-3.492-1.746Z",
    transform: "translate(-134.963 -213.437)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9496",
    "data-name": "Path 9496",
    d: "M147.56,267.933s7.284,8.443,10.482,6.11,2.912-9.9,0-12.228S146.981,263.855,147.56,267.933Z",
    transform: "translate(-130.835 -211.999)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9497",
    "data-name": "Path 9497",
    d: "M164.215,236.229s.293,7.864-1.746,13.1-5.824,8.736-6.4,11.649-.293,6.991-3.206,8.157-2.912-.873-2.619-3.206.873-11.062.873-11.062l-9.624,5.817s2.619,7.284-2.912,8.157-12.228-7.57-13.1-13.951,2.619-20.679,8.736-24.464,13.974-3.2,18.06-3.2S162.454,230.119,164.215,236.229Z",
    transform: "translate(-125.344 -203.591)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9498",
    "data-name": "Path 9498",
    d: "M144.556,228.151s-1.5.753-4.131,4.884,2.626,7.691,5.448,5.817.369-5.817,2.438-7.7a6.675,6.675,0,0,0,2.257-3.943Z",
    transform: "translate(-128.9 -203.595)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9499",
    "data-name": "Path 9499",
    d: "M134.124,235.764a5.937,5.937,0,0,0-2.446,4.131c-.188,2.626,4.515-2.257,5.072-4.515S134.124,235.764,134.124,235.764Z",
    transform: "translate(-126.91 -205.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9500",
    "data-name": "Path 9500",
    d: "M156.939,228.191a7.638,7.638,0,0,0,.293,7.856c2.619,4.079,8.443,5.824,10.768,2.912s3.206-4.364,2.333-5.817S161.017,225.858,156.939,228.191Z",
    transform: "translate(-132.929 -203.703)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M177.422,206.053a7.721,7.721,0,0,1-6.11-2.039c-2.912-2.619-5.538-8.443-6.7-8.157s-5.267,8.736-5.267,8.736-6.991.587-7.57,2.619,2.619,11.649,5.267,15.727a14.034,14.034,0,0,0,11.062,6.133c3.492,0,13.974.873,15.434-2.626s.286-13.974.286-13.974,4.665-4.658,2.626-5.531S177.422,206.053,177.422,206.053Z",
    transform: "translate(-131.869 -195.832)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9502",
    "data-name": "Path 9502",
    d: "M180.885,227.808c-.354-.459-.692-.926-1.023-1.407a3.538,3.538,0,0,0-4.357-1.264c-3.567,1.121-6.02,4.515-2.062,7.322C177.167,235.13,184.647,232.722,180.885,227.808Z",
    transform: "translate(-136.746 -203.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9503",
    "data-name": "Path 9503",
    d: "M161.884,204.588s4.079,2.333,6.4,1.46.873-10.776-1.159-10.2S161.591,200.8,161.884,204.588Z",
    transform: "translate(-134.383 -195.828)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9504",
    "data-name": "Path 9504",
    d: "M195.488,210.567a8.108,8.108,0,0,0-6.118,2.325c-2.355,2.619-.873,5.267,2.333,5.824S196.647,210.567,195.488,210.567Z",
    transform: "translate(-140.905 -199.473)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9505",
    "data-name": "Path 9505",
    d: "M166.7,231.751s-3.762-2.912-2.912-.587,2.325,2.626,3.762,2.039S166.7,231.751,166.7,231.751Z",
    transform: "translate(-134.828 -204.351)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9506",
    "data-name": "Path 9506",
    d: "M164.269,221.979c-.218.753-.835,1.279-1.377,1.129s-.805-.9-.587-1.678.835-1.279,1.377-1.129S164.487,221.212,164.269,221.979Z",
    transform: "translate(-134.473 -201.878)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9507",
    "data-name": "Path 9507",
    d: "M176.254,231c-.7.406-1.505.346-1.776-.143s.045-1.2.753-1.61a1.309,1.309,0,0,1,1.776.135C177.278,229.871,176.947,230.593,176.254,231Z",
    transform: "translate(-137.481 -204.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9508",
    "data-name": "Path 9508",
    d: "M142.056,255.841s-.873,6.4.286,9.03,2.333,12.521,4.665,12.792,1.452-5.267,1.452-6.118.293-10.189.293-10.189,2.039-4.372,3.2-6.7",
    transform: "translate(-129.402 -210.389)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M129.39,255.747s7.864-2.333,8.736,6.4",
    transform: "translate(-126.345 -210.588)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M159.57,260.359s6.7-3.5,6.991-11.069",
    transform: "translate(-133.815 -209.06)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-118",
    transform: "translate(52 104.477)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y1: 1.121,
    x2: 4.959,
    transform: "translate(0 129.971)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M107,314.98l39.988-11.34a5.546,5.546,0,0,1,3.619.873l65.068,41.575a1.61,1.61,0,0,1-.67,2.95l-54.721,17.044Z",
    transform: "translate(-65.613 -154.624)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M138.07,321.294l5.666,3.905,6.547-1.851-5.659-3.9Z",
    transform: "translate(-73.303 -158.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M138.743,335.125l-5.659-3.905-6.554,1.851,5.666,3.905Z",
    transform: "translate(-70.447 -161.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    "data-name": "Path 9514",
    d: "M156.99,324.471l5.659,3.9,6.547-1.851-5.659-3.9Z",
    transform: "translate(-77.985 -159.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M165.76,330.511l5.659,3.9,6.547-1.851-5.659-3.9Z",
    transform: "translate(-80.156 -160.824)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M146.84,327.334l5.659,3.905,6.547-1.851-5.659-3.9Z",
    transform: "translate(-75.473 -160.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M127.92,324.161l5.659,3.905,6.554-1.851-5.666-3.905Z",
    transform: "translate(-70.791 -159.252)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M183.955,356.415l-5.666-3.905-6.539,1.851,5.659,3.905Z",
    transform: "translate(-81.639 -166.727)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M173.8,359.285l-5.659-3.905-6.547,1.851,5.666,3.9Z",
    transform: "translate(-79.124 -167.437)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M147.505,341.165l-5.659-3.905-6.547,1.851,5.659,3.9Z",
    transform: "translate(-72.617 -162.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M192.715,362.458l-5.659-3.9L180.51,360.4l5.659,3.905Z",
    transform: "translate(-83.807 -168.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9522",
    "data-name": "Path 9522",
    d: "M156.273,347.205l-5.666-3.905-6.547,1.851,5.666,3.9Z",
    transform: "translate(-74.785 -164.447)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    "data-name": "Path 9523",
    d: "M165.035,353.245l-5.659-3.905-6.547,1.851,5.659,3.905Z",
    transform: "translate(-76.956 -165.942)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M174.52,336.551l5.659,3.9,6.547-1.851-5.659-3.9Z",
    transform: "translate(-82.324 -162.319)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M136.69,330.2l5.659,3.905,6.547-1.851-5.659-3.9Z",
    transform: "translate(-72.961 -160.75)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    "data-name": "Path 9526",
    d: "M202.865,359.588l-5.659-3.9-6.547,1.851,5.659,3.9Z",
    transform: "translate(-86.319 -167.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    "data-name": "Path 9527",
    d: "M176.575,341.468l-5.659-3.9-6.547,1.844,5.659,3.905Z",
    transform: "translate(-79.812 -163.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    "data-name": "Path 9528",
    d: "M157.655,338.3,152,334.39l-6.547,1.851,5.659,3.905Z",
    transform: "translate(-75.129 -162.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9529",
    "data-name": "Path 9529",
    d: "M122.668,323.578l-3.311-2.288-4.477,1.257,2.619,2.491Z",
    transform: "translate(-67.563 -159)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9530",
    "data-name": "Path 9530",
    d: "M130.364,329.085l-5.659-3.905-5.365,1.52,4.432,4.2.045.03Z",
    transform: "translate(-68.667 -159.962)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    "data-name": "Path 9531",
    d: "M155.6,333.381l5.666,3.9,6.547-1.851-5.666-3.9Z",
    transform: "translate(-77.641 -161.534)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9532",
    "data-name": "Path 9532",
    d: "M166.425,344.338l-5.659-3.9-6.547,1.844,5.659,3.905Z",
    transform: "translate(-77.3 -163.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9533",
    "data-name": "Path 9533",
    d: "M204.255,350.678l-5.659-3.9-6.547,1.851,5.659,3.9Z",
    transform: "translate(-86.663 -165.309)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9534",
    "data-name": "Path 9534",
    d: "M183.28,342.591l5.666,3.9,6.547-1.851-5.659-3.9Z",
    transform: "translate(-84.492 -163.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9535",
    "data-name": "Path 9535",
    d: "M194.105,353.548l-5.659-3.9L181.9,351.5l5.659,3.9Z",
    transform: "translate(-84.151 -166.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9536",
    "data-name": "Path 9536",
    d: "M185.335,347.508l-5.659-3.9-6.547,1.844,5.666,3.905Z",
    transform: "translate(-81.98 -164.524)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9537",
    "data-name": "Path 9537",
    d: "M175.185,350.378l-5.659-3.9-6.547,1.844,5.659,3.905Z",
    transform: "translate(-79.468 -165.234)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9538",
    "data-name": "Path 9538",
    d: "M139.343,344.028l-5.659-3.9-.5.143,4.462,4.237Z",
    transform: "translate(-72.092 -163.663)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9539",
    "data-name": "Path 9539",
    d: "M205.977,361.73l-6.547,1.851,6.788,4.673,6.381-1.964Z",
    transform: "translate(-88.49 -169.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    "data-name": "Path 9540",
    d: "M195.817,364.6l-6.547,1.844,6.991,4.816,6.374-1.964Z",
    transform: "translate(-85.975 -169.719)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M155.957,356.108l-5.659-3.9-3.288.926,4.47,4.244Z",
    transform: "translate(-75.515 -166.653)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M213.023,356.718l-5.666-3.9-6.547,1.851,5.666,3.9Z",
    transform: "translate(-88.831 -166.803)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M164.262,362.155,158.6,358.25l-4.673,1.324,4.462,4.237Z",
    transform: "translate(-77.228 -168.147)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M172.571,368.2l-5.659-3.905-6.073,1.716,4.47,4.237Z",
    transform: "translate(-78.938 -169.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M182.565,365.325l-5.659-3.905-6.547,1.851,5.659,3.905Z",
    transform: "translate(-81.295 -168.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M231.76,357.7,228,355.34l-8.277,2.34,6.4,4.41,4.982-1.5a1.558,1.558,0,0,0,.662-2.89Z",
    transform: "translate(-93.511 -167.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M175.217,370.33l-7.457,2.107,5.869,5.568,8.8-2.709Z",
    transform: "translate(-80.651 -171.137)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M218.849,349.45l-7.879,2.227,5.659,3.9,8.24-2.325Z",
    transform: "translate(-91.346 -165.969)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M216.127,358.86l-6.547,1.851,6.592,4.545,6.381-1.964Z",
    transform: "translate(-91.002 -168.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M156.066,314.095l5.35-1.513-3.454-2.182-5.162,1.445Z",
    transform: "translate(-76.948 -156.304)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    "data-name": "Path 9551",
    d: "M192.68,372.3l-7.013-4.839-6.547,1.851,7.179,4.951Z",
    transform: "translate(-83.463 -170.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    "data-name": "Path 9552",
    d: "M158.38,315.668l5.659,3.9,5.772-1.625-6.02-3.8Z",
    transform: "translate(-78.33 -157.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    "data-name": "Path 9553",
    d: "M175.91,327.671l5.659,3.9,6.592-1.859-6.012-3.8Z",
    transform: "translate(-82.668 -160.143)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M167.14,321.668l5.666,3.9,6.178-1.746-6.02-3.8Z",
    transform: "translate(-80.498 -158.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    "data-name": "Path 9555",
    d: "M184.67,333.671l5.659,3.9,7.006-1.972-6.012-3.808Z",
    transform: "translate(-84.836 -161.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    "data-name": "Path 9556",
    d: "M193.44,339.674l5.659,3.9,7.412-2.092-6.012-3.8Z",
    transform: "translate(-87.007 -163.056)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    "data-name": "Path 9557",
    d: "M209.672,343.56l-7.472,2.115,5.659,3.9,7.826-2.2Z",
    transform: "translate(-89.175 -164.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    "data-name": "Path 9558",
    d: "M148.23,318.431l5.659,3.9,6.547-1.851-5.659-3.9Z",
    transform: "translate(-75.817 -157.834)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    "data-name": "Path 9559",
    d: "M130.66,337.94l1.159,1.091.3-.09Z",
    transform: "translate(-71.469 -163.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    "data-name": "Path 9560",
    d: "M125.591,322.564l6.547-1.851-3.3-2.273-6.562,1.836Z",
    transform: "translate(-69.395 -158.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    "data-name": "Path 9561",
    d: "M135.746,319.7l6.547-1.851-3.281-2.265-6.562,1.844Z",
    transform: "translate(-71.912 -157.586)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    "data-name": "Path 9562",
    d: "M142.63,314.574l3.281,2.258,6.547-1.851-3.273-2.25Z",
    transform: "translate(-74.431 -156.881)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    "data-name": "Path 9563",
    d: "M147.645,350.075l-5.659-3.905-1.9.534,4.47,4.237Z",
    transform: "translate(-73.803 -165.158)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9564",
    "data-name": "Path 9564",
    d: "M155.219,347.8l-17.307-70.065a8.443,8.443,0,0,0-2.446-4.154l-46.655-43.5a1.264,1.264,0,0,0-2.092,1.212L101.972,296.7Z",
    transform: "translate(-60.585 -136.341)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9565",
    "data-name": "Path 9565",
    d: "M143,284.19l5.335,4.665s1.663.331,3.326,8.661",
    transform: "translate(-74.523 -149.817)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 9.835,
    y2: 42.621,
    transform: "translate(78.139 152.026)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9566",
    "data-name": "Path 9566",
    d: "M113.976,278.881c2.31,5.614,2.1,11.024-.474,12.085s-6.539-2.634-8.849-8.277-2.1-11.024.474-12.078S111.666,273.268,113.976,278.881Z",
    transform: "translate(-64.635 -146.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9567",
    "data-name": "Path 9567",
    d: "M113.976,278.881c2.31,5.614,2.1,11.024-.474,12.085s-6.539-2.634-8.849-8.277-2.1-11.024.474-12.078S111.666,273.268,113.976,278.881Z",
    transform: "translate(-64.635 -146.412)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 3.582,
    cy: 7.818,
    rx: 3.582,
    ry: 7.818,
    transform: "translate(38.39 128.521) rotate(-22.38)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9568",
    "data-name": "Path 9568",
    d: "M119.941,310.9c1.2,2.912.707,5.877-1.1,6.622s-4.244-1.016-5.448-3.92-.7-5.877,1.106-6.622S118.745,308,119.941,310.9Z",
    transform: "translate(-67.033 -155.417)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9569",
    "data-name": "Path 9569",
    d: "M117.876,316.445c-1.136,0-2.37-1.031-3.01-2.641a4.914,4.914,0,0,1-.361-2.634,2.152,2.152,0,0,1,1.219-1.753c1.272-.527,2.9.579,3.695,2.513h0c.79,1.934.414,3.86-.858,4.387a1.822,1.822,0,0,1-.685.128Zm-1.5-6.4a.933.933,0,0,0-.376.075,1.43,1.43,0,0,0-.752,1.181,4.146,4.146,0,0,0,.316,2.257c.61,1.505,1.851,2.453,2.709,2.1s1.061-1.911.444-3.4c-.564-1.317-1.588-2.212-2.34-2.212Z",
    transform: "translate(-67.459 -156.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100",
    transform: "translate(47 153.257)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9570",
    "data-name": "Path 9570",
    d: "M117.876,316.445c-1.136,0-2.37-1.031-3.01-2.641a4.914,4.914,0,0,1-.361-2.634,2.152,2.152,0,0,1,1.219-1.753c1.272-.527,2.9.579,3.695,2.513h0c.79,1.934.414,3.86-.858,4.387a1.822,1.822,0,0,1-.685.128Zm-1.5-6.4a.933.933,0,0,0-.376.075,1.43,1.43,0,0,0-.752,1.181,4.146,4.146,0,0,0,.316,2.257c.61,1.505,1.851,2.453,2.709,2.1s1.061-1.911.444-3.4c-.564-1.317-1.588-2.212-2.34-2.212Z",
    transform: "translate(-114.458 -309.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9571",
    "data-name": "Path 9571",
    d: "M138.676,313.335l-4.282,6.772a1,1,0,0,0,0,1.114l9.165,13.364a1.023,1.023,0,0,0,1.5.211l4.748-3.875a1.008,1.008,0,0,0,.233-1.3l-9.639-16.246a1.008,1.008,0,0,0-1.731-.038Z",
    transform: "translate(-72.351 -156.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9572",
    "data-name": "Path 9572",
    d: "M129.933,324.378s11.859-1.972,20.009,14.734l2.024-2.491s-7.849-13.071-14.245-14.237A59.251,59.251,0,0,0,129,321.21Z",
    transform: "translate(-71.058 -158.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9573",
    "data-name": "Path 9573",
    d: "M129.933,324.378s11.859-1.972,20.009,14.734l2.024-2.491s-7.849-13.071-14.245-14.237A59.251,59.251,0,0,0,129,321.21Z",
    transform: "translate(-71.058 -158.98)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y1: 4.372,
    x2: 19.354,
    transform: "translate(7.728 124.974)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9574",
    "data-name": "Path 9574",
    d: "M221.71,333.51a61.848,61.848,0,0,1-7.006.7c-3.635.143-5.177.143-4.62.986s4.906,1.678,6.441,1.957S221.71,333.51,221.71,333.51Z",
    transform: "translate(-91.099 -162.024)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x1: 6.479,
    y1: 3.386,
    transform: "translate(260.604 198.538)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9575",
    "data-name": "Path 9575",
    d: "M234.94,268.561s1.362-2.385,1.934.572Z",
    transform: "translate(-97.278 -145.724)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x1: 157.964,
    y1: 82.526,
    transform: "translate(98.63 113.912)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9576",
    "data-name": "Path 9576",
    d: "M188.59,297.178l33.193,21.4,27.3-11.137L212.309,288.75Z",
    transform: "translate(-85.807 -150.946)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 13.229,
    y2: 4.673,
    transform: "translate(110.888 141.77)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9577",
    "data-name": "Path 9577",
    d: "M202.12,302.3l23.869,15.05,19.452-7.525",
    transform: "translate(-89.155 -154.3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9578",
    "data-name": "Path 9578",
    d: "M364.717,165.56s19.008,3.01,25.126,13.2,1.746,26.2-.293,31.733c-1.844,5.019,3.6,9.211,6.953,11.935,7.525,6.11,11.4,14.734,7.487,24.117-2.438,5.839-13.282,8.458-11.814,15.486s7.856,16.886-.293,24.17c-8.6,7.675-21.506,3.717-29.046-3.454-8.481-8.067-11.4-22.1-7.058-32.944,5.267-13.1,8.15-21.544,3.2-27.09s-11.355-9.03-11.355-16.886,6.991-10.189,9.9-18.06-1.166-16.013-1.166-16.013Z",
    transform: "translate(-125.167 -120.456)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9579",
    "data-name": "Path 9579",
    d: "M393.023,183.62c3.672,2.777,7.013,7.45,5.854,15.05C396.53,214.1,385.13,215.1,392.5,224.827s14.087,5.358,12.74,17.428-5.7,16.427-5.7,16.427",
    transform: "translate(-135.67 -124.926)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9580",
    "data-name": "Path 9580",
    d: "M383.55,178.69a20.823,20.823,0,0,1,4.259,1.505",
    transform: "translate(-134.06 -123.706)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9581",
    "data-name": "Path 9581",
    d: "M378.65,184.49s9.722,2.679,12.74,10.723S382.36,209.97,381.668,215",
    transform: "translate(-132.847 -125.141)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9582",
    "data-name": "Path 9582",
    d: "M366.707,336.162c-.135-4.613-.2-10.768.083-17.262.587-13.394,16.6-31.161,17.179-34.359s-.873-3.762-.873-3.762l-31.74-13.688c-14.756,9.692-18.346,37.881-19.226,51.034Z",
    transform: "translate(-121.333 -145.585)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9583",
    "data-name": "Path 9583",
    d: "M391,286.41s2.664,1.663,0,4.327-9.993,13.989-13,20.648",
    transform: "translate(-132.686 -150.367)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9584",
    "data-name": "Path 9584",
    d: "M375.583,324a26.33,26.33,0,0,0-1.994,10.655c.339,5.328.331,10.324.331,10.324",
    transform: "translate(-131.586 -159.67)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9585",
    "data-name": "Path 9585",
    d: "M292.76,255.069c1.4,3.642,3.085,11.476,1.964,15.953a112.433,112.433,0,0,1-4.244,11.37l42.794,22.364c-.045-8.91.068-22.974,1.2-25.585,1.678-3.921,15.118-40.868,14.3-49.266S331.7,209.468,331.7,209.468L334.192,189l-14.832,8.962s-1.686,8.112-3.364,10.076-15.4,4.756-19.317,9.782-2.521,20.438-2.521,21.273S291.36,251.457,292.76,255.069Z",
    transform: "translate(-111.025 -126.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101",
    transform: "translate(179.455 62.743)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9586",
    "data-name": "Path 9586",
    d: "M357.859,229.876c-.843-8.4-17.074-20.438-17.074-20.438L343.3,189l-14.832,8.962s-.489,2.34-1.2,4.816c.956-.083,2.024-.218,3.221-.429a24.369,24.369,0,0,0,8.661-3.01L336.142,212s15.321,9.03,19.317,19.986c.542,1.5,1.121,2.912,1.716,4.312a24.831,24.831,0,0,0,.685-6.419Z",
    transform: "translate(-299.586 -189)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9588",
    "data-name": "Path 9588",
    d: "M292.76,255.069c1.4,3.642,3.085,11.476,1.964,15.953a112.433,112.433,0,0,1-4.244,11.37l42.794,22.364c-.045-8.91.068-22.974,1.2-25.585,1.678-3.921,15.118-40.868,14.3-49.266S331.7,209.468,331.7,209.468L334.192,189l-14.832,8.962s-1.686,8.112-3.364,10.076-15.4,4.756-19.317,9.782-2.521,20.438-2.521,21.273S291.36,251.457,292.76,255.069Z",
    transform: "translate(-111.025 -126.257)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9589",
    "data-name": "Path 9589",
    d: "M292.76,262.351c1.4,3.642,3.085,11.476,1.964,15.953a112.433,112.433,0,0,1-4.244,11.37l42.794,22.364c-.045-8.91.068-22.974,1.2-25.585,1.678-3.921,15.118-40.868,14.3-49.266-.519-5.23-7.006-11.859-11.829-16.126C332.2,226.1,321.9,235.487,314.372,231.3c-6.772-3.762-6.344-9.481-5.343-12.883-4.575,1.686-10.046,3.838-12.3,6.727-3.92,5.042-2.521,20.438-2.521,21.273S291.36,258.739,292.76,262.351Z",
    transform: "translate(-111.025 -133.539)",
    fill: "#4f5d64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9590",
    "data-name": "Path 9590",
    d: "M320.382,260.706l-9.316-4.372s-2.626-4.364-4.079-4.364-2.333,6.118-2.333,6.118-4.944,4.658-3.2,9.316,8.15,11.649,16.013,9.03S323,265.665,323,265.665s3.206-5.531,3.206-6.7S320.382,260.706,320.382,260.706Z",
    transform: "translate(-113.649 -141.843)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9591",
    "data-name": "Path 9591",
    d: "M299.97,138.491s1.964,10.083,1.678,17.082-3.078,9.782-2.257,12.875,10.919,14.561,17.074,15.674,20.716-8.4,24.915-12.6a15.63,15.63,0,0,0,4.2-12.875c-.557-2.521-2.8-22.673-11.2-30.792S303.891,120.582,299.97,138.491Z",
    transform: "translate(-113.193 -109.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102",
    transform: "translate(186.047 13.024)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9592",
    "data-name": "Path 9592",
    d: "M340.379,127.859c-3.138-3.01-8.195-4.816-13.5-4.929l-.346,10.445s-1.671,10.324,4.327,18.647,11.325,10.663,11.987,13.989-2.348,6.637-9.993,12.326a57.677,57.677,0,0,1-9.564,5.869c6.554.233,20.062-8.654,24.08-12.68a15.63,15.63,0,0,0,4.2-12.875C351.012,156.13,348.754,135.978,340.379,127.859Z",
    transform: "translate(-305.193 -122.929)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9594",
    "data-name": "Path 9594",
    d: "M299.97,138.491s1.964,10.083,1.678,17.082-3.078,9.782-2.257,12.875,10.919,14.561,17.074,15.674,20.716-8.4,24.915-12.6a15.63,15.63,0,0,0,4.2-12.875c-.557-2.521-2.8-22.673-11.2-30.792S303.891,120.582,299.97,138.491Z",
    transform: "translate(-113.193 -109.904)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9595",
    "data-name": "Path 9595",
    d: "M313.608,171.14s-.843,5.32-2.258,7a6.968,6.968,0,0,0,3.921,1.686",
    transform: "translate(-116.19 -121.837)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9596",
    "data-name": "Path 9596",
    d: "M315.09,188.817a12.792,12.792,0,0,0,11.476-.557",
    transform: "translate(-117.116 -126.074)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9597",
    "data-name": "Path 9597",
    d: "M327.837,166.868c0,.933-.436,1.686-.978,1.686s-.978-.753-.978-1.686.436-1.678.978-1.678S327.837,165.943,327.837,166.868Z",
    transform: "translate(-119.787 -120.364)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9598",
    "data-name": "Path 9598",
    d: "M309.427,163.9c0,.926-.436,1.678-.978,1.678s-.978-.752-.978-1.678.436-1.678.978-1.678S309.427,162.973,309.427,163.9Z",
    transform: "translate(-115.23 -119.629)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9599",
    "data-name": "Path 9599",
    d: "M305.05,154.436a6.9,6.9,0,0,1,5.32-.843",
    transform: "translate(-114.631 -117.443)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9600",
    "data-name": "Path 9600",
    d: "M322.53,155.1s1.678-.843,5.32,1.4",
    transform: "translate(-118.957 -117.828)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9601",
    "data-name": "Path 9601",
    d: "M314.969,127.632s-7.833,6.441-11.754,10.354-5.6,6.72-11.476,4.206-10.083-11.2-2.258-21.559,22.959-13.44,37.79-9.241,21,13.718,22.116,24.08-1.129,21.83-6.4,24.915-17.082-9.519-21.281-17.36A111.627,111.627,0,0,1,314.969,127.632Z",
    transform: "translate(-109.718 -106.6)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9602",
    "data-name": "Path 9602",
    d: "M317.443,133.57s-21.138,3.115-22.138,7.8,5.365,3.356,5.365,3.356",
    transform: "translate(-112.193 -112.538)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9603",
    "data-name": "Path 9603",
    d: "M291.483,137.68c-1.43,3.055-.293,5.049-.293,5.049",
    transform: "translate(-111.094 -113.555)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9604",
    "data-name": "Path 9604",
    d: "M338.272,120.131s-20.453-3.349-20.453,5.7c0,0-12.4-4.357-20.445,1.678a20.536,20.536,0,0,0-3.3,3.01",
    transform: "translate(-111.913 -109.062)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9605",
    "data-name": "Path 9605",
    d: "M327,130.58s5.215,16.826,16.1,21.123",
    transform: "translate(-120.064 -111.798)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9606",
    "data-name": "Path 9606",
    d: "M341.42,136.59c4.191,3.461,10.189,6.878,17.307,6.539",
    transform: "translate(-123.633 -113.286)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9607",
    "data-name": "Path 9607",
    d: "M332.76,127.46a34.484,34.484,0,0,0,3.221,3.815",
    transform: "translate(-121.489 -111.026)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9608",
    "data-name": "Path 9608",
    d: "M297.157,156.637l32.749,5.6s0,4.982-1.4,7.525-3.078,2.574-6.72,2.574-8.706-2.257-8.955-3.078c-.579-1.987-.188-8.541-.188-8.541l-2.611-.421s.339,7.638-1.061,8.481-10.64-.843-12.318-3.078S296.036,156.351,297.157,156.637Z",
    transform: "translate(-112.336 -118.245)",
    fill: "none",
    stroke: "#962cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9609",
    "data-name": "Path 9609",
    d: "M341.13,163.251l14.561-2.521v1.956l-14.561,3.642Z",
    transform: "translate(-123.561 -119.26)",
    fill: "#fff",
    stroke: "#962cc6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 12.981,
    cy: 8.119,
    rx: 12.981,
    ry: 8.119,
    transform: "translate(224.784 55.973) rotate(-80.87)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9610",
    "data-name": "Path 9610",
    d: "M374.057,162.913c-.956,5.96-4.274,10.377-7.4,9.873s-4.891-5.734-3.936-11.694,4.267-10.369,7.4-9.865S375.013,156.961,374.057,162.913Z",
    transform: "translate(-128.842 -116.899)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9611",
    "data-name": "Path 9611",
    d: "M371.17,131.993a66.37,66.37,0,0,1-2.521,23.237s-.278,4.515,3.921,2.521,3.642-19.038,3.078-26.036S369.777,126.672,371.17,131.993Z",
    transform: "translate(-130.371 -110.961)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9612",
    "data-name": "Path 9612",
    d: "M349.155,113.491s6.434-1.678,9.782,4.206,2.8,11.2,7.525,11.754,5.042-4.756,2.521-11.476-7.833-11.762-15.118-12.318A12.1,12.1,0,0,0,343,110.978S346.913,111.535,349.155,113.491Z",
    transform: "translate(-124.024 -105.621)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9613",
    "data-name": "Path 9613",
    d: "M314.014,251.463,294.7,295.416s-52.63,9.782-57.385,9.782-14.3,3.356-16.239,4.515-20.972,9.9-17.307,10.437c2.257.339,8.1-2.875,8.1-2.875s-9.241,4.515-8.405,5.877,12.04-4.2,12.04-4.2-10.241,6.02-8.142,6.359c1.911.339,4.221-.753,6.186-2.16a22.757,22.757,0,0,1,5.486-2.438s-4.515,3.01-5.049,4.38,1.121.557,2.8,0a69.407,69.407,0,0,0,9.083-4.741c1.114-.843,4.477-2.521,6.72-4.477l4.477-3.921s29.949.835,43.645.278,20.438-1.956,25.479-7S325.5,268.281,328.854,259.6s1.121-13.718-2.258-19.565",
    transform: "translate(-89.447 -138.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103",
    transform: "translate(113.852 101.15)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9614",
    "data-name": "Path 9614",
    d: "M326.274,283.357c-9.03,16.984-16.653,22.311-24.644,26.337s-51.96,5-51.96,5l1.851.444c7.939.2,29.588.655,40.635.2,13.718-.557,20.438-1.956,25.479-7s19.317-36.955,22.673-45.631a19.972,19.972,0,0,0,1.5-10.159l-1.9,1.2A269.89,269.89,0,0,1,326.274,283.357Z",
    transform: "translate(-214.776 -243.136)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9616",
    "data-name": "Path 9616",
    d: "M314.014,251.463,294.7,295.416s-52.63,9.782-57.385,9.782-14.3,3.356-16.239,4.515-20.972,9.9-17.307,10.437c2.257.339,8.1-2.875,8.1-2.875s-9.241,4.515-8.405,5.877,12.04-4.2,12.04-4.2-10.241,6.02-8.142,6.359c1.911.339,4.221-.753,6.186-2.16a22.757,22.757,0,0,1,5.486-2.438s-4.515,3.01-5.049,4.38,1.121.557,2.8,0a69.407,69.407,0,0,0,9.083-4.741c1.114-.843,4.477-2.521,6.72-4.477l4.477-3.921s29.949.835,43.645.278,20.438-1.956,25.479-7S325.5,268.281,328.854,259.6s1.121-13.718-2.258-19.565",
    transform: "translate(-89.447 -138.89)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9617",
    "data-name": "Path 9617",
    d: "M348.067,250.359,342.19,265.6c4.319-2.3,12.424-5.4,18.888-.753.91-2.137,1.655-3.943,2.152-5.23,3.364-8.676,1.121-13.718-2.257-19.565",
    transform: "translate(-123.823 -138.892)",
    fill: "#4f5d64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9618",
    "data-name": "Path 9618",
    d: "M277.87,280.62c-5.681,1.663-28.121,8.232-30.205,8.721a32.051,32.051,0,0,1-3.921.7s-7.841-3.364-9.94-4.9-4.62-.564-5.877,0-2.257,4.477.143,4.477,2.8-.143,5.456,2.1,2.664,3.364,4.62,4.2,5.185.278,6.863,0c1.5-.248,27.526-1.979,33.93-2.318C279.773,290.079,278.938,284.578,277.87,280.62Z",
    transform: "translate(-95.216 -148.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    transform: "translate(131.392 131.686)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9619",
    "data-name": "Path 9619",
    d: "M284.817,286,251.06,297.287c1.5-.248,27.526-1.979,33.93-2.318A24.678,24.678,0,0,0,284.817,286Z",
    transform: "translate(-232.66 -281.952)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9621",
    "data-name": "Path 9621",
    d: "M277.87,280.62c-5.681,1.663-28.121,8.232-30.205,8.721a32.051,32.051,0,0,1-3.921.7s-7.841-3.364-9.94-4.9-4.62-.564-5.877,0-2.257,4.477.143,4.477,2.8-.143,5.456,2.1,2.664,3.364,4.62,4.2,5.185.278,6.863,0c1.5-.248,27.526-1.979,33.93-2.318C279.773,290.079,278.938,284.578,277.87,280.62Z",
    transform: "translate(-95.216 -148.934)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9622",
    "data-name": "Path 9622",
    d: "M218.859,292.77s-2.942,1.678-3.762,3.635.835,1.4,1.4.986S219.438,295,219.438,295Z",
    transform: "translate(-92.312 -151.941)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9623",
    "data-name": "Path 9623",
    d: "M220.781,290.9a3.364,3.364,0,0,0-1.505,3.364c.278,2.378,2.8,5.877,3.085,4.477S220.781,290.9,220.781,290.9Z",
    transform: "translate(-93.391 -151.478)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9624",
    "data-name": "Path 9624",
    d: "M224.7,288.11s-2.664.7-3.5,2.1.557,7.427,1.543,7.841a1.5,1.5,0,0,0,2.1-1.114C225.126,295.951,224.7,288.11,224.7,288.11Z",
    transform: "translate(-93.816 -150.787)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9625",
    "data-name": "Path 9625",
    d: "M228.885,286.25s-3.507,0-3.921,1.686-1.121,8.955-.421,10.076,1.821.7,2.378-.7S228.885,286.25,228.885,286.25Z",
    transform: "translate(-94.632 -150.327)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9626",
    "data-name": "Path 9626",
    d: "M232.749,268.92,227,295.1l.9,3.341a.3.3,0,0,0,.5.135l2.513-2.5,4.2-26.458Z",
    transform: "translate(-95.313 -146.038)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9627",
    "data-name": "Path 9627",
    d: "M238.668,297s-3.221,1.264-5.742,2.385-5.042,1.678-4.763,3.221,1.4.978,3.221.421a38.323,38.323,0,0,1,7.706-1.821c3.5-.421,6.3-3.642,6.3-3.642",
    transform: "translate(-95.596 -152.988)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9628",
    "data-name": "Path 9628",
    d: "M227.1,304.25l.587,2.468a.7.7,0,0,0,1.159.346l1.377-1.309",
    transform: "translate(-95.338 -154.782)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y1: 13.259,
    x2: 2.972,
    transform: "translate(131.694 135.802)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 37.963,
    y2: 35.307,
    transform: "translate(28.851 97.072)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar1);
export default __webpack_public_path__ + "static/media/char1.ad1e696f93216f94a95f232e42d6445b.svg";
export { ForwardRef as ReactComponent };